<template>
  <div class="GlobalFormDemo">
    <GlobalForm ref="form" :init-data="initData" :form-item-list="formItemList" :inline="true" :labelWidth="90" round :needBtnLoading="true"
      @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item class="el_from" label="回收商名称" slot="operationSelect" style="margin:0">
        <el-select v-model="merchantId" placeholder="请选择回收商" filterable clearable @change="handleChange">
          <el-option v-for="item in shanpsSelectList" :key="item.merchantId" :label="item.merchantName"
            :value="item.merchantId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="交易门店" slot="operationSelect" style="margin:0">
        <el-select v-model="storeId" placeholder="请先选择交易门店" :disabled="isHasCompany" filterable clearable
          @change="handleChangeStore">
          <el-option v-for="item in storeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="原始订单号" slot="orderNo" style="margin:0">
        <el-input v-model="orderNo" clearable placeholder="请输入原始订单号查询"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="账单类型" slot="orderNo" style="margin:0">
        <el-select v-model="opt" placeholder="请选择账单类型查询" filterable clearable @change="handleChangeOpt">
          <el-option v-for="item in optList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="账单子类型" slot="serTypeList" style="margin:0">
        <el-select v-model="serType" placeholder="请选择账单子类型" filterable clearable @change="handleChangeSerType">
          <el-option v-for="item in serTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-button v-if="info.isNicePay && isCustomUser" slot="AddSlot" type="warning" @click="shiftBill">调账</el-button> -->
      <el-button v-if="info.isOpenRenewSubsidy && info.niceMerchantAccount.name" slot="AddSlot" type="warning" @click="shiftBill">调账</el-button>
      <el-button icon="el-icon-download" slot="AddSlot" type="success"  :loading="exportLoading" @click="exportBillBefore">导出账单</el-button>
    </GlobalForm>
    <!--弹框-->
    <el-dialog v-if="info.isNicePay" title="门店商余额调账到靓机回收商" :visible.sync="dialogVisible" :close-on-click-modal="false"
      width="500px" @closed="handleDialogClosed">
      <el-form class="balance-form" ref="form" :model="transferData" label-width="100px">
        <el-form-item label="出账商家：">
          <el-input size="small" disabled placeholder="请输入出账商家" v-model="info.companyAccount.name"></el-input>
        </el-form-item>
        <el-form-item label="入账商家：">
          <el-input size="small" disabled placeholder="请输入入账商家" v-model="info.niceMerchantAccount.name"></el-input>
        </el-form-item>
        <el-form-item label="联系人：">
          <el-input size="small" disabled placeholder="请输入联系人姓名" v-model="info.contactName"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话：">
          <el-input size="small" disabled placeholder="请输入联系人电话" v-model="info.contactPhone"></el-input>
        </el-form-item>
        <el-form-item label="上账金额：">
          <el-input size="small" placeholder="请输入上账金额" @input="limitInput($event)"
            v-model.trim="transferData.amountPrice"></el-input>
          <span v-if="NumMoney" style="color:#F83232;font-weight: bold;">{{
            NumMoney
          }}</span>
        </el-form-item>
      </el-form>
      <div style="color:#0981FF; font-size:16px">
        当前账户余额：￥{{ info.companyAccount.balance }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="butLoading" @click.native="handleSuccess">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="操作提示" :visible.sync="codeShow" :close-on-click-modal="false" width="500px" @closed="closeExport">
      <div class="code-tip">
        <div class="tip-sure">是否确认导出订单？</div>
      </div>
      <div class="command">
        <div style="width: 88px;">动态口令：</div>
        <el-input v-model="code" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="closeExport">取消</el-button>
        <el-button type="primary" :loading="codeLoading" @click.native="codeSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formValidateMobile } from "@/utils/form-validate";
import moment from "moment";
import _api from "@/utils/request";
export default {
  name: "Form",
  props: {
    accountType: {
      require: true,
      type: String
    },
    info: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      isCustomUser: "",
      initData:  {
        entryTime: [
          moment().day(moment().day()-30).format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      merchantId: "",
      companyId: "",
      storeId: "",
      opt: "",
      shanpsSelectList: [],
      InquirySelectList: [],
      storeList: [],
      serTypeList: [],
      serType: "",
      orderNo: "",
      isHasCompany: false,
      formItemList: [
        { slotName: 'operationSelect' },
        {
          key: "uniqNo",
          type: "input",
          labelName: "账单流水号",
          placeholder: "请输入账单流水号查询",
        },
        { slotName: 'orderNo' },
        { slotName: 'opt' },
        { slotName: 'serTypeList' },
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "时间",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
          lableWidth: '60',
          clearable: true,
        },
      ],
      optList: [
        {
          value: '01',
          label: '入账',
        },
        {
          value: '02',
          label: '出账',
        },
        {
          value: '03',
          label: '挂账',
        },
      ],
      transferData: {
        amountPrice: "",
      },
      NumMoney: "",
      butLoading: false,
      dialogVisible: false,
      exportLoading: false,
      codeShow: false,
      codeLoading: false,
      code: "",
    };
  },
  created() {
    this.isCustomUser = JSON.parse(localStorage.getItem('user')).xcxStaffId
    const params = {
      pageNum: 0,
      pageSize: 999,
    }
    this.orderNo = this.$route.query.orderNo || ""
    _api.listSimpleMerchantView(params).then((res) => {
      if (res.code === 1) {
        this.shanpsSelectList = res.data
      }
    })
    _api.getSerTypeList({ opt: this.opt,accountType: 'company' }).then((res) => {
      if (res.code === 1) {
        this.serTypeList = res.data
      }
    })
    _api.getStoreSelectOrder().then(res => {
      console.log(res);
      if (res.code === 1) {
        this.storeList = res.data
      }
    })
    this.handleConfirm(this.initData);
  },

  watch: {
    accountType(val) {
      if (val == 'merchant') {
        this.orderNo = ""
        this.handleConfirm();
      }
      _api.getSerTypeList({ opt: this.opt,accountType: 'company' }).then((res) => {
        if (res.code === 1) {
          this.serTypeList = res.data
        }
      })
    }
  },
  methods: {
    handleConfirm(data,cd) {
      console.log("提交了form", data);
      let SeachParams = {};
      if (this.orderNo) {
        SeachParams = {
          orderNo: this.orderNo
        };
      }
      if (data) {
        SeachParams = {
          merchantId: this.merchantId || "",
          storeId: this.storeId || "",
          uniqNo: data.uniqNo || "",
          orderNo: this.orderNo || data.orderNo || "",
          opt: this.opt || "",
          serType: this.serType || "",
          startTime: data.entryTime ? moment(data.entryTime[0]).format("x") : "",
          endTime: data.entryTime ? moment(data.entryTime[1]).format("x") : "",
          pageNum: 1,
          pageSize: 10,
        };
      }
      this.formData = JSON.parse(JSON.stringify(SeachParams));
      SeachParams.disuseLoding = () => {
        if (typeof cd === 'function') {
          cd()
        }
      },
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    handleChange(val) {
      this.merchantId = val
      console.log(this.merchantId)
    },
    handleChangeSerType(val) {
      this.serType = val
    },
    handleChangeOpt(val) {
      this.opt = val
      this.serType = ""
      _api.getSerTypeList({ opt: this.opt,accountType: 'company' }).then((res) => {
        if (res.code === 1) {
          this.serTypeList = res.data
        }
      })
    },
    handleChangeStore(val) {
      console.log(val)
      this.storeId = val
    },
    exportBillBefore() {
      let userInfo = localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{}
      _api.needValid({account:userInfo.userAcc}).then(res=>{
        if(res.data){
          this.codeShow = true
        }else{
          this.exportBill()
        }
      })
    },
    exportBill() {
      console.log(this.formData);
      let params = {
        accountType: "company",
        merchantId: this.merchantId || "",
        storeId: this.storeId || "",
        uniqNo: this.formData.uniqNo || "",
        orderNo: this.formData.orderNo || "",
        opt: this.formData.opt || "",
        serType: this.serType || "",
        startTime: this.formData.startTime ? this.formData.startTime : "",
        endTime: this.formData.endTime ? this.formData.endTime : "",
        pageNum: 1,
        pageSize: 10,
        command: this.code,
      };
      this.exportLoading = true
      _api.exportExcel(params).then(res => {
        console.log(res)
        const content = res;
        const blob = new Blob([content]);

        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "账单.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
        this.exportLoading = false
        this.codeLoading = false
        this.codeShow = false
      }).catch(err => {
        this.exportLoading = false
        this.codeLoading = false
        console.log(err)
      });
    },
    // 调账
    shiftBill() {
      this.dialogVisible = true
    },
    handleDialogClosed() {
      this.$emit('refresh')
    },
    // 确认调账
    handleSuccess() {
      if (!this.transferData.amountPrice) {
        this.$message.error("请输入上账金额");
        return;
      }
      let params = {
        merchantId: this.info.niceMerchantAccount.id,
        contacts: this.info.contactName,
        contactsPhone: this.info.contactPhone,
        amountPrice: Number(this.transferData.amountPrice),
      };
      console.log(params);
      this.butLoading = true;
      _api
        .writeOffAccount(params)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success(res.msg || "操作成功");
            this.transferData.amountPrice = ""
            this.NumMoney = ""
            this.handleConfirm(this.formData)
            this.$emit('refresh')
          }
          this.dialogVisible = false;
          this.butLoading = false;
        })
        .catch((err) => {
          if (err.msg == '账户余额不足') {
            this.transferData.amountPrice = ""
            this.NumMoney = ""
          }
          this.$emit('refresh')
          this.butLoading = false;
        });
    },
    limitInput(value) {
      let str = (value && value.split("")) || [];
      let reg1 = /\d/;
      let reg2 = /\./;
      // 第一个字符不能为小数点
      if (str[0] == ".") {
        this.transferData.amountPrice = "";
        return;
      }
      // 过滤掉除数字和小数点外的字符
      value = str.filter((e) => reg1.test(e) || reg2.test(e));
      // 匹配小数点后只能有两位小数
      let valJoin = value.join("");
      this.transferData.amountPrice = valJoin.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      if (this.transferData.amountPrice > this.info.companyAccount.balance) {
        this.transferData.amountPrice = this.info.companyAccount.balance
      }
      this.NumMoney = this.transferData.amountPrice
        ? this.changeNumMoneyToChinese(this.transferData.amountPrice)
        : "";
    },
    // 金额大写
    changeNumMoneyToChinese(money) {
      var cnNums = new Array(
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖"
      ); //汉字的数字
      var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
      var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
      var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
      var cnInteger = "整"; //整数金额时后面跟的字符
      var cnIntLast = "元"; //整型完以后的单位
      var maxNum = 999999999999999.9999; //最大处理的数字
      var IntegerNum; //金额整数部分
      var DecimalNum; //金额小数部分
      var ChineseStr = ""; //输出的中文金额字符串
      var parts; //分离金额后用的数组，预定义
      var Symbol = ""; //正负值标记
      if (money == "") {
        return "";
      }

      money = parseFloat(money);
      if (money >= maxNum) {
        alert("超出最大处理数字");
        return "";
      }
      if (money == 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger;
        return ChineseStr;
      }
      if (money < 0) {
        money = -money;
        Symbol = "负 ";
      }
      money = money.toString(); //转换为字符串
      if (money.indexOf(".") == -1) {
        IntegerNum = money;
        DecimalNum = "";
      } else {
        parts = money.split(".");
        IntegerNum = parts[0];
        DecimalNum = parts[1].substr(0, 4);
      }
      if (parseInt(IntegerNum, 10) > 0) {
        //获取整型部分转换
        var zeroCount = 0;
        var IntLen = IntegerNum.length;
        for (var i = 0; i < IntLen; i++) {
          var n = IntegerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              ChineseStr += cnNums[0];
            }
            zeroCount = 0; //归零
            ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            ChineseStr += cnIntUnits[q];
          }
        }
        ChineseStr += cnIntLast;
        //整型部分处理完毕
      }
      if (DecimalNum != "") {
        //小数部分
        var decLen = DecimalNum.length;
        for (let i = 0; i < decLen; i++) {
          let n = DecimalNum.substr(i, 1);
          if (n != "0") {
            ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (ChineseStr == "") {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (DecimalNum == "") {
        ChineseStr += cnInteger;
      }
      ChineseStr = Symbol + ChineseStr;

      return ChineseStr;
    },
    closeExport() {
      this.codeShow = false
      this.code = ""
    },
    codeSubmit() {
      if (!this.code) {
        return this.$message.error("请输入谷歌动态码");
      }
      this.codeLoading = true
      this.exportBill()
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .balance-form {
    /deep/.el-form-item__label {
      line-height: 32px;
    }

    /deep/.el-form-item__content {
      line-height: 32px;
    }
  }
}
.command {
  display: flex;
  align-items: center;
}

.command .el-input {
  width: 80%;
}
.code-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;

  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }
}
</style>
